import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const registerFCMToken = async (authToken: string) => {
  try {
    const fcmToken = await getFCMToken();

    if (!fcmToken) {
      console.warn('FCM token not generated');
      return;
    }

    console.log('Generated FCM token:', fcmToken);

    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/device-tokens`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          token: fcmToken,
          platform: 'web',
          deviceInfo: navigator.userAgent,
        }),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Token registration failed');
    }

    console.log('✅ FCM token registered:', result);
  } catch (error) {
    console.error('❌ FCM registration failed:', error);
  }
};

// export const getFCMToken = async (): Promise<string | null> => {
//   try {
//     const supported = await isSupported();
//     if (!supported) {
//       console.warn('⚠️ FCM not supported in this browser');
//       return null;
//     }

//     const messaging = getMessaging(app);
//     const permission = await Notification.requestPermission();
//     if (permission !== 'granted') {
//       console.warn('⚠️ Notification permission denied');
//       return null;
//     }

//     const token = await getToken(messaging, {
//       vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
//     });

//     return token || null;
//   } catch (error: any) {
//     console.error('❌ FCM token error:', error.message);
//     return null;
//   }
// };
export const getFCMToken = async (): Promise<string | null> => {
  try {
    if (!(await isSupported())) {
      console.warn('FCM not supported');
      return null;
    }

    const messaging = getMessaging(app);

    const permission =
      Notification.permission === 'granted'
        ? 'granted'
        : await Notification.requestPermission();

    if (permission !== 'granted') {
      return null;
    }

    // Explicitly register the root-scope Firebase service worker
    const registration = await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js',
      { scope: '/' }
    );

    await navigator.serviceWorker.ready;

    console.log('FCM Service Worker Scope:', registration.scope);

    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    console.log('Generated FCM token:', token);

    return token || null;

  } catch (error: any) {
    console.error('FCM token error:', error.message);
    return null;
  }
};
export const onForegroundMessage = async (
  handler: (payload: any) => void
) => {
  const supported = await isSupported();
  if (!supported) return;
  const messaging = getMessaging(app);
  onMessage(messaging, handler);
};

export { app };